import React from 'react';
import Icon from '../../assets/images/icons/bargraph.png';

const Bargraph = ({ ...props }) => (
  <img style={{ margin: 'auto' }} width="100%" src={Icon} {...props} alt="icon" />
);

export default Bargraph;
